import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service'
import { TranslateServiceService } from '../services/translate-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  // Race data
  raceUrl: string;
  raceId: string;

  // Pages
  pagesList: any;

  // Translate service
  notCurrentLanguage: string;
  text: any;
  currentLanguageNav: string;

  // Social Network List
  socialNetworks: any;

  // Config all races
  socialNetworksAllRaces: any = null;

  // Is all allRaces
  isAllRaces: boolean = false;

  constructor(
    private apiService: ApiConnectionService,
    private translateService: TranslateServiceService,
    private router: Router
  ) {
    let _ = this;
    _.getCurrentLanguage();
  }

  ngOnInit() {
    let _ = this;
    if (!_.getRaceName()){
      _.configByMerchant();
      _.isAllRaces = true;
    }
  }

  ngAfterViewInit(){
    let _ = this;
    _.getQuantities();
  }

  getCurrentLanguage() {
    let _ = this;
    let isEN = _.translateService.getCurrentLanguage() === 'EN';
    _.translateService.getJSON("assets/translations/footer.translations.json")
      .subscribe((res)=> {
        if(isEN){
          _.text = res.english;
          _.notCurrentLanguage = 'ES';
          _.currentLanguageNav = 'en';
        }else{
          _.text = res.spanish;
          _.notCurrentLanguage = 'EN';
          _.currentLanguageNav = 'es';
        }
      });
  }

  getRaceName(){
    let _ = this;
    let raceName: any = location.href.split('/');

    return raceName[4];
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getPages(){
    let _ = this;
  	let conditions = {
      "conditions":{},
      "race_id": _.raceId,
      "merchant": _.getMerchant()
  	}

    _.apiService.getPages(conditions).subscribe(data => {
      _.pagesList = data['results'];
    })
  }

  getQuantities(){
    let _ = this;
    let conditions = {
      "conditions":{
        "race_url": _.getRaceName(),
        "active": true,
      },
      "merchant": _.getMerchant(),
    }

    _.apiService.getQuantities(conditions).subscribe(data => {
      _.raceUrl = data['results'][0].race_url;
      _.socialNetworks = data['results'][0].design.social_networks;
      _.raceId = data['results'][0].race_id;

      _.getPages();
    })
  }

  specialPageParser(urlPage){
    let _ = this;
    let isHttps = urlPage.indexOf('http');

    if(isHttps != -1){
      window.open(urlPage, '_blank')
      return;
    }

    _.router.navigate(['/' + _.getMerchant() + '/' + _.getRaceName() + '/dynamic/' + urlPage]);
  }

  configByMerchant(){
    let _ = this;
    let conditions = {
     "conditions":{
        "merchant": _.getMerchant(),
      },
    }
    _.apiService.getMerchantDesign(conditions).subscribe(data => {
      _.socialNetworksAllRaces = data['results'][0].design.social_media;
      console.log(_.socialNetworksAllRaces);
    })
  }
}
